import Highway from '@dogstudio/highway/src/highway'
import LocomotiveScroll from 'locomotive-scroll'
import lottie from 'lottie-web'
import { debounce, throttle } from 'underscore'

import SplitTextJS from 'split-text-js'
import gsap from 'gsap'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'
import MotionTime from '../js/modules/MotionTime'

import ContactIcon from './modules/ContactIcon'

import '../scss/_SingleCrea.scss'
import motionTimeLuvAnimation from '../anims/motiontime/luv.json'

gsap.registerPlugin(ScrollToPlugin)

export default class SingleCrea extends Highway.Renderer {
    onEnter() {
        this.allBlocks = Array.from(
            document.querySelectorAll('.section__block-singleCreas')
        )
        this.blocksAnimations = []
        this.currentBlock = 0
        this.prepareAnimations()
        this.motionTime = new MotionTime()
        this.mouseCoords = {
            x: window.innerWidth / 2,
            y: window.innerHeight / 2,
        }
        this.flowRAFInstance = null
    }

    onEnterCompleted() {
        this.allBlocks.push(document.querySelector('.footer'))
        this.scroll = new LocomotiveScroll()

        // Motion Time counting case studies
        const nbCaseStudies = this.motionTime.addCaseStudy(location.pathname)
        // const nbCaseStudies = 4;
        let motionTimeStorage = this.motionTime.getStorage()

        const caseStudyNameContainer = document.querySelector(
            '.intro__fullName-container'
        )
        const caseStudyName = caseStudyNameContainer.querySelector(
            '.intro__fullName'
        )

        if (nbCaseStudies == 4) {
            if (motionTimeStorage.achievements[2] == 'locked') {
                let allChars = caseStudyName.querySelectorAll(
                    '.SplitTextJS-char'
                )

                setTimeout(() => {
                    allChars.forEach((char, index) => {
                        let randomRotation = Math.random() * 30 - 15
                        let randomX = Math.random() * 400 - 200
                        let randomFall = Math.random() * 200 + 100

                        gsap.to(char, {
                            duration: 0.4,
                            opacity: 0,
                            ease: 'expo.easeOut',
                            y: randomFall,
                            x: randomX,
                            delay: index * 0.005,
                            rotation: randomRotation,
                            onComplete: () => {
                                if (index == allChars.length - 1) {
                                    setTimeout(() => {
                                        gsap.to(allChars, {
                                            duration: 0.4,
                                            opacity: 1,
                                            rotation: 0,
                                            y: 0,
                                            x: 0,
                                            stagger: 0.05,
                                        })
                                    }, 1000)
                                }
                            },
                        })

                        this.motionTime.unlockItem(2)
                    })
                }, 3000)
            }
        } else {
            if (nbCaseStudies >= 3) {
                let caseStudyNameText = caseStudyName.textContent
                let caseStudyNameHTML = caseStudyName.innerHTML

                for (let i = 0; i < 10; i++) {
                    let caseStudyNameClone = document.createElement('div')
                    caseStudyNameClone.innerHTML = caseStudyNameHTML
                    let toClear = caseStudyNameClone.querySelectorAll(
                        '.SplitTextJS-char'
                    )

                    gsap.set(toClear, {
                        clearProps: 'transform,opacity',
                    })
                    caseStudyNameClone.classList.add('name__clone')

                    caseStudyNameContainer.appendChild(caseStudyNameClone)
                }

                // TODO : Desktop only. Sur mobile une animation constante avec une sin wave.
                window.addEventListener(
                    'mousemove',
                    throttle((e) => {
                        this.mouseCoords.x = e.clientX
                        this.mouseCoords.y = e.clientY
                    }),
                    50
                )

                this.flowRAFInstance = window.requestAnimationFrame(
                    this.flowRAF.bind(this)
                )

                this.motionTime.unlockItem(1)

                // intersection obs for performance : cancel when not in view.
                const flowIntersectionObserver = new IntersectionObserver(
                    (entries) => {
                        if (entries[0].isIntersecting) {
                            this.flowRAFInstance = window.requestAnimationFrame(
                                this.flowRAF.bind(this)
                            )
                        } else {
                            window.cancelAnimationFrame(this.flowRAFInstance)
                        }
                    },
                    {
                        root: document.querySelector('null'),
                        rootMargin: '-100px',
                        treshold: [0, 1],
                    }
                )

                flowIntersectionObserver.observe(caseStudyName)
            }
        }

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        if (this.blocksAnimations[this.currentBlock]) {
                            this.blocksAnimations[this.currentBlock].play(0)
                        }
                        entry.target.classList.add('inview')
                    } else {
                        entry.target.classList.remove('inview')
                    }
                })
            },
            {
                root: document.querySelector('null'),
                rootMargin: '-100px',
                treshold: [0, 1],
            }
        )

        this.allBlocks.forEach((block) => {
            observer.observe(block)
        })

        this.scrollEventGlobal = debounce(
            this.scrollEvent.bind(this),
            100,
            true
        )

        window.addEventListener('wheel', this.scrollEventGlobal)

        // Setup MotionTime LUV
        motionTimeStorage = this.motionTime.getStorage()
        if (motionTimeStorage.achievements[3] == 'locked') {
            const motionTimeLuvContainer = document.querySelector(
                '.motionTime__luv-container'
            )

            this.motionTimeLuvAnimation = lottie.loadAnimation({
                path: motionTimeLuvAnimation,
                container: motionTimeLuvContainer,
                renderer: 'svg',
                autoplay: false,
                loop: false,
                rendererSettings: {
                    preserveAspectRatio: 'xMidYMid slice',
                },
            })

            this.motionTimeLuvAnimation.addEventListener('complete', () => {
                motionTimeLuvContainer.classList.remove('active')
            })
        }

        // Setup MotionTime Contact
        const contactIconInstance = new ContactIcon('gsap', false)
        contactIconInstance.contactContainer.addEventListener('click', () => {
            this.currentBlock = this.allBlocks.length - 1
        })

        // Image lazy loading

        const allImages = document.querySelectorAll('img[data-src]')
        const imagesObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (
                    entry.isIntersecting &&
                    !entry.target.classList.contains('loaded')
                ) {
                    const imgUrl = entry.target.getAttribute('data-src')
                    let img = new Image()
                    img.onload = () => {
                        entry.target.classList.add('loaded')
                        entry.target.setAttribute('src', imgUrl)
                    }
                    img.src = imgUrl
                }
            })
        })

        allImages.forEach((image) => {
            imagesObserver.observe(image)
        })

        this.touchInit()
    }

    flowRAF() {
        this.flowRAFInstance = window.requestAnimationFrame(
            this.flowRAF.bind(this)
        )
        let clones = document.querySelectorAll('.name__clone')
        let container = document.querySelector('.intro__fullName-container')
        let direction = 1

        if (this.mouseCoords.y - window.innerHeight / 2 < 0) {
            direction = -1
        }

        for (let i = 0; i < clones.length; i++) {
            let currentClone = clones[i]
            currentClone.style.transform =
                'translate3d(' +
                (this.mouseCoords.x - window.innerWidth / 2) * 0.02 * i +
                'px, ' +
                (this.mouseCoords.y - window.innerHeight / 2) * 0.035 * i +
                'px, 0)'
            currentClone.style.opacity =
                0.05 * (clones.length - i) -
                direction *
                    ((this.mouseCoords.y - window.innerHeight / 2) * 0.0005)
            // currentClone.style.opacity = Math.min(0.3, 1 / i) - direction * ((this.mouseCoords.y - window.innerHeight / 2) * 0.0002);
        }

        container.style.transform =
            'translate3d(' +
            (this.mouseCoords.x - window.innerWidth / 2) * 0.02 +
            'px, ' +
            (this.mouseCoords.y - window.innerHeight / 2) * 0.02 +
            'px, 0)'
    }

    onLeave() {
        this.scroll.destroy()
        window.cancelAnimationFrame(this.flowRAFInstance)
        window.removeEventListener('wheel', this.scrollEventGlobal)

        document.removeEventListener('touchstart', this.tsInstance)
        document.removeEventListener('touchend', this.teInstance)
    }

    scrollEvent(e) {
        if (e.deltaY > 0) {
            if (this.currentBlock < this.allBlocks.length - 1) {
                this.currentBlock++
            }
        } else {
            if (this.currentBlock > 0) {
                this.currentBlock--
            }
        }

        this.moveScrollPosition()
    }

    moveScrollPosition() {
        if (this.currentBlock == this.allBlocks.length - 1) {
            const motionTimeStorage = this.motionTime.getStorage()
            if (motionTimeStorage.achievements[3] == 'locked') {
                const motionTimeLuvContainer = document.querySelector(
                    '.motionTime__luv-container'
                )
                motionTimeLuvContainer.classList.add('active')
                this.motionTime.unlockItem(3)
                setTimeout(() => {
                    this.motionTimeLuvAnimation.play()
                }, 400)
            }
        }

        gsap.to(window, {
            duration: 1,
            ease: 'expo.out',
            scrollTo: this.allBlocks[this.currentBlock],
            onComplete: () => {
                // this.blocksAnimations[this.currentBlock].play(0);
            },
        })

        // scroll header fix
        const header = document.querySelector('.header')

        if (this.currentBlock == 0) {
            header.classList.remove('smaller')
        } else {
            header.classList.add('smaller')
        }
    }

    prepareAnimations() {
        this.allBlocks.forEach((block) => {
            let tl = new gsap.timeline({
                paused: true,
            })
            if (block.classList.contains('singleCrea__introduction')) {
                const introName = block.querySelector('.intro__fullName')

                if (introName) {
                    const introNameSplit = new SplitTextJS(introName)

                    tl.add(
                        gsap.from(introNameSplit.chars, {
                            duration: 1.5,
                            stagger: 0.05,
                            opacity: 0,
                            y: 250,
                            ease: 'expo.out',
                        }),
                        0
                    )
                }

                const introCategory = block.querySelector(
                    '.intro__content-category'
                )

                if (introCategory) {
                    const introCategorySplit = new SplitTextJS(introCategory)

                    tl.add(
                        gsap.from(introCategorySplit.chars, {
                            duration: 1,
                            y: 10,
                            stagger: 0.05,
                            opacity: 0,
                            ease: 'expo.out',
                        }),
                        0
                    )
                }

                const introDate = block.querySelector('.intro__content-date')

                if (introDate) {
                    const introDateSplit = new SplitTextJS(introDate)

                    tl.add(
                        gsap.from(introDateSplit.chars, {
                            duration: 1,
                            opacity: 0,
                            stagger: 0.05,
                            y: 10,
                            ease: 'expo.out',
                        }),
                        0
                    )
                }

                const introText = block.querySelector('.intro__content-text')

                if (introText) {
                    tl.add(
                        gsap.from(introText, {
                            duration: 1.5,
                            opacity: 0,
                            y: 250,
                            ease: 'expo.out',
                        }),
                        0
                    )
                }
            } else if (
                block.classList.contains('imgLeft_txtRight') ||
                block.classList.contains('txtLeft_imgRight') ||
                block.classList.contains('txtOnly') ||
                block.classList.contains('vidLeft_txtRight')
            ) {
                const blockTitle = block.querySelector(
                    '.block__contentPart-title'
                )
                const blockText = block.querySelector(
                    '.block__contentPart-text'
                )

                if (blockText.classList.contains('quote')) {
                    const blockTextQuoteSplit = new SplitTextJS(blockText)
                    let quoteStagger = 0.025

                    if (blockTextQuoteSplit.chars.length > 120) {
                        quoteStagger = 0.015
                    }

                    tl.add(
                        gsap.from(blockTextQuoteSplit.chars, {
                            duration: 1,
                            stagger: quoteStagger,
                            opacity: 0,
                            x: 10,
                            ease: 'expo.out',
                        }),
                        0
                    )
                } else {
                    tl.add(
                        gsap.from(blockText, {
                            duration: 1,
                            opacity: 0,
                            y: 250,
                            ease: 'expo.out',
                        }),
                        0
                    )
                }

                tl.add(
                    gsap.from(blockTitle, {
                        duration: 1,
                        opacity: 0,
                        ease: 'expo.out',
                        y: 250,
                    }),
                    0
                )
            }

            this.blocksAnimations.push(tl)
        })
        // this.allBlocks.forEach((block) => {
        //     let blockTimeline = gsap.timeline({
        //         paused: true
        //     });

        //     const blockDirection = block.getAttribute('data-direction') ? block.getAttribute('data-direction') : 'vertical';

        //     if (blockDirection == 'horizontal') {
        //         blockTimeline.add(gsap.from(block, {
        //             x: '100%',
        //             opacity: 0,
        //             ease: 'expo.out',
        //             duration: 1
        //         }), 0);
        //     } else {
        //         blockTimeline.add(gsap.from(block, {
        //             y: '100%',
        //             opacity: 0,
        //             ease: 'expo.out',
        //             duration: 1
        //         }), 0);
        //     }

        //     // if (block.classList.contains('imgLeft_txtRight') || block.classList.contains('txtLeft_imgRight')) {
        //     //     const blockImage = block.querySelector('.block__imagePart-inner');
        //     //     const blockContent = block.querySelector('.block__contentPart');
        //     //     const blockTitle = blockContent.querySelector('.block__contentPart-title');
        //     //     const blockText = blockContent.querySelector('.block__contentPart-text');

        //     //     if (blockText.classList.contains('quote')) {
        //     //         const blockTextQuoteSplit = new SplitTextJS(blockText);

        //     //         blockTimeline.add(gsap.from(blockTextQuoteSplit.chars, {
        //     //             stagger: 0.025,
        //     //             duration: 0.4,
        //     //             x: 10,
        //     //             scale: 1.15,
        //     //             ease: 'expo.out',
        //     //             opacity: 0
        //     //         }));
        //     //     }

        //     //     blockTimeline.add(gsap.from(blockImage, {
        //     //         opacity: 0,
        //     //         y: 100,
        //     //         duration: 1.5,
        //     //         ease: 'expo.out',
        //     //     }), 0);

        //     //     blockTimeline.add(gsap.from(blockTitle, {
        //     //         opacity: 0,
        //     //         y: 200,
        //     //         duration: 1.5,
        //     //         ease: 'expo.out',
        //     //     }), 0);

        //     //     blockTimeline.add(gsap.from(blockText, {
        //     //         opacity: 0,
        //     //         y: 200,
        //     //         duration: 1.5,
        //     //         ease: 'expo.out',
        //     //     }), 0);
        //     // } else {
        //     //     blockTimeline.from(block, {
        //     //         opacity: 0,
        //     //         duration: 0.4,
        //     //         ease: 'expo.out²'
        //     //     });
        //     // }

        //     this.blocksAnimations.push(blockTimeline);
        // });
    }

    touchStartEvent(e) {
        this.ts = e.touches[0].clientY
    }

    touchEndEvent(e) {
        this.te = e.changedTouches[0].clientY

        if (this.ts > this.te + 5) {
            // console.log('slide down');
            if (this.currentBlock < this.allBlocks.length - 1) {
                this.currentBlock++
            }
        } else if (this.ts < this.te - 5) {
            // console.log('slide up');
            if (this.currentBlock > 0) {
                this.currentBlock--
            }
        }

        this.moveScrollPosition()
    }

    touchInit() {
        // Fixing touch
        this.ts = null
        this.tsInstance = this.touchStartEvent.bind(this)
        this.teInstance = this.touchEndEvent.bind(this)
        document.addEventListener('touchstart', this.tsInstance)
        document.addEventListener('touchend', this.teInstance)
    }
}
